import React, { useRef } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Box, Tooltip } from '@agilize/components-core';
import { routes } from '@routes/routes';
import { Routes } from '@routes/Routing.types';
import { matchPath } from 'react-router';
import useClickOutside from '@utils/hooks/useClickOutside';
import { Container, Line, Content, MobileRouteName, Nav } from './NavSidebar.styles';
import { NavSidebarProps } from './NavSidebar.types';

const NavSidebar = (props: NavSidebarProps) => {
  const { active, closeMenu } = props;
  const { pathname } = useLocation();
  const ref = useRef();

  useClickOutside(ref, closeMenu);

  const matchRoute = (route: Routes) => {
    const mainRoute = {
      path: route.path,
      exact: route.exact,
      strict: false,
    };

    const alternativeRoutes = (route?.alternativeUrls || []).map(altRoute => ({
      path: altRoute,
      exact: true,
      strict: false,
    }));

    const routesToMatch = [mainRoute, ...alternativeRoutes];

    let matched = false;
    routesToMatch.forEach(currentMatch => {
      const match = matchPath(pathname, currentMatch);

      if (match) {
        matched = true;
      }
    });

    return matched;
  };

  return (
    <Container active={active} count={routes.length} ref={ref}>
      <Nav>
        {routes.map(route => (
          <NavLink key={route.label} isActive={() => matchRoute(route)} to={route.path} exact={route.exact} onClick={closeMenu}>
            <Tooltip tooltipClassName="hide-not-desktop" className="tooltip-nav-bar" title={route.label} placement="right" display="block">
              <Content>
                <Box minWidth={[40, 40, 0]}>{route.icon} </Box>
                <MobileRouteName>{route.label}</MobileRouteName>
              </Content>
            </Tooltip>
          </NavLink>
        ))}
        <Line />
      </Nav>
    </Container>
  );
};

export default NavSidebar;
